/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return ParameterBase.fixupPrototype; }

    static newInstance(model: Partial<ParameterBase>): ParameterBase {
        let obj = Object.assign(new ParameterBase(), model);
        ParameterBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterBase>): ParameterBase {
        if (!model) return null;
        return ParameterBase.newInstance(<ParameterBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterBase) {
        if (!obj) return;

        models.ParameterBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterBase): boolean {
        switch (obj.__type)
        {
            case "ParameterArray":
                Object.setPrototypeOf(obj, models.ParameterArray.prototype);
                break;
            case "ParameterBaseWithSchema":
                Object.setPrototypeOf(obj, models.ParameterBaseWithSchema.prototype);
                break;
            case "ParameterBooleanType":
                Object.setPrototypeOf(obj, models.ParameterBooleanType.prototype);
                break;
            case "ParameterJsonBlob":
                Object.setPrototypeOf(obj, models.ParameterJsonBlob.prototype);
                break;
            case "ParameterMap":
                Object.setPrototypeOf(obj, models.ParameterMap.prototype);
                break;
            case "ParameterNumberType":
                Object.setPrototypeOf(obj, models.ParameterNumberType.prototype);
                break;
            case "ParameterObject":
                Object.setPrototypeOf(obj, models.ParameterObject.prototype);
                break;
            case "ParameterStringType":
                Object.setPrototypeOf(obj, models.ParameterStringType.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ParameterBase)[] {
        return [
            models.ParameterArray,
            models.ParameterBaseWithSchema,
            models.ParameterBooleanType,
            models.ParameterJsonBlob,
            models.ParameterMap,
            models.ParameterNumberType,
            models.ParameterObject,
            models.ParameterStringType,
        ];
    }

    fixupFields() {
    }

    /**
     * A brief explanation of the policy parameter
     */
    description: string;

    /**
     * Default value of the parameter, encoded as a JSON string. This is the schema's own authored default - it does not change per execution
     */
    default_value: string;

    /**
     * The value to actually use for this execution, encoded as a JSON string. Distinct from default_value: this is what the caller supplies (or what gets live-resolved, e.g. via a selected cloud account) for one specific run, and never overwrites the schema's own default
     */
    actual_value: string;

    /**
     * Hide/Show a parameter for visibility as part of deployment
     */
    hide_parameter: boolean;

    /**
     * Live-lookup reference used to populate this parameter's allowed values, for example 'vpc.list_vpc'. Present when the values come from a cloud resource listing instead of a fixed list, so the caller can resolve the current values itself
     */
    source: string;

}
